const codePattern = /^([0-9]{5})(-?)([A-Z]{4})(-?)([0-9]{4})$/i

function getCode (object, addSeparator) {
	if (!object.codigo) {
		return { error: true, msg: 'Objeto sem sequencial' }
	} else if (!object.curadoriaCodigo) {
		return { error: true, msg: 'Curadoria sem código' }
	} else if (!object.tipoCodigo) {
		return { error: true, msg: 'Tipo de objeto sem código' }
	} else {
		const mm = object.dtInsert.replace(/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})(.*)$/, '$2')
		const yy = object.dtInsert.replace(/^([0-9]{2})\/([0-9]{2})\/([0-9]{2})([0-9]{2})(.*)$/, '$4')
		let codigo = ''

		if (addSeparator) {
			codigo = `${object.codigo.trim().padStart(5, '0')}-${object.tipoCodigo}${object.curadoriaCodigo}-${yy}${mm.trim().padStart(2, '0')}`
		} else {
			codigo = `${object.codigo.trim().padStart(5, '0')}${object.tipoCodigo}${object.curadoriaCodigo}${yy}${mm.trim().padStart(2, '0')}`
		}

		return codigo
	}
}

function formatCode (code, template) {
	let formattedCode = ''

	if (!template || template === 'without-separator') {
		formattedCode = code.replace(/-/g, '')
	} else if (template === 'sequence') {
		formattedCode = code.replace(codePattern, '$1')
	} else if (template === 'with-separator') {
		formattedCode = code.replace(codePattern, '$1-$3-$5')
	}

	return formattedCode
}

export { codePattern, getCode, formatCode }
